import "../../css/banker-page.css";
import { Input } from "antd";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const AdminPage = () => {
    return (
        <div>AdminPage.tsx</div>
    )
}

export default AdminPage;